var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _c("div", { staticClass: "both-pd-box1" }, [
      _c(
        "div",
        {
          staticStyle: {
            background: "#fff",
            padding: "10px 30px",
            "border-radius": "20px",
          },
        },
        [
          _c("h3", [_vm._v("好评反馈弹窗")]),
          _vm._v(" "),
          _c("el-divider"),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("div", { staticClass: "tips" }, [
                _vm._v(
                  "仅向已提现用户展示，用户提现成功后，会以弹窗的形式向用户展示好评的反馈入口;"
                ),
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "form",
                  staticClass: "demo-form",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-width": "200px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "好评反馈弹窗:", prop: "radio" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.form.radio,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "radio", $$v)
                            },
                            expression: "form.radio",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("打开"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("关闭"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "iOS App Store地址:", prop: "iosLink" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "800px" },
                        attrs: { placeholder: "请输入", clearable: "" },
                        model: {
                          value: _vm.form.iosLink,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "iosLink", $$v)
                          },
                          expression: "form.iosLink",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.handleSubmit },
                        },
                        [_vm._v("\n              保存\n            ")]
                      ),
                      _vm._v(" "),
                      _c("el-button", { on: { click: _vm.handleReset } }, [
                        _vm._v("重置"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }